module.exports = function() {
  return new Worker(__webpack_public_path__ + "ffa33e7e5fe18e601416.worker.js");
};